import { Eye, EyeOff } from "lucide-react"
import * as React from "react"

import { Button } from "@/components/ui-kit/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { cn } from "@/lib/utils"

export const FormBox = React.forwardRef<
  HTMLInputElement,
  Omit<React.ComponentProps<typeof Input>, "type" | "value" | "defaultValue" | "onChange"> & {
    id: string
    label: string
    type?: "text" | "email" | "password" | "tel"
    defaultValue?: string
    onChange?: React.ChangeEventHandler<HTMLInputElement>
  }
>(function FormBox(
  {
    id,
    label,
    type = "text",
    className,
    defaultValue = "",
    onChange,
    ...props
  },
  ref,
) {
  const [value, setValue] = React.useState(defaultValue)
  const [focused, setFocused] = React.useState(false)
  const [showPassword, setShowPassword] = React.useState(false)
  const isPassword = type === "password"
  const inputType = isPassword && !showPassword ? "password" : isPassword ? "text" : type
  const active = focused || value.length > 0

  return (
    <div className={cn("relative rounded-lg bg-input", className)}>
      <Label
        htmlFor={id}
        className={cn(
          "pointer-events-none absolute left-4 text-lg leading-6 text-muted-foreground transition-all duration-300",
          active ? "top-2 translate-y-0 text-sm leading-5" : "top-[18px] -translate-y-0"
        )}
      >
        {label}
      </Label>
      <Input
        ref={ref}
        id={id}
        type={inputType}
        value={value}
        onChange={(e) => {
          setValue(e.target.value)
          onChange?.(e)
        }}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        className={cn(
          "h-auto border-0 bg-transparent pr-14 pt-8 pb-2 pl-4 text-lg leading-6 shadow-none focus-visible:ring-0 aria-invalid:ring-1 aria-invalid:ring-destructive",
          isPassword ? "pr-14" : "pr-4"
        )}
        {...props}
      />
      {isPassword ? (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className={cn(
            "absolute top-1/2 right-3 -translate-y-1/2 text-muted-foreground",
            !active && "pointer-events-none opacity-0",
            active && "opacity-100"
          )}
          aria-label={showPassword ? "Скрыть пароль" : "Показать пароль"}
          onClick={() => setShowPassword((v) => !v)}
        >
          {showPassword ? <EyeOff /> : <Eye />}
        </Button>
      ) : null}
    </div>
  )
})
